'use client';

import React from 'react';

import { SocialIcon as ReactSocialIcon } from 'react-social-icons';
import { resolveSetting } from '../../../utils/settingsHelper';

export function SocialIcon({ href, background, color, settings }) {
	return (
		<ReactSocialIcon
			url={href}
			target="_blank"
			className={background !== 'transparent' ? 'hover:brightness-150' : 'hover:backdrop-brightness-150'}
			bgColor={resolveSetting(background, settings)}
			fgColor={resolveSetting(color, settings)}
		/>
	);
}
